import SlideOverHeader from "../../../component/header";
import SlideOverBody from "../../../component/body";
import useSlideOver from "../../../useSlideOver";
import SlideOverFooter from "../../../component/footer";
import Button from "../../../../button";
import Divider from "../../../../divider/divider";
import {useEffect, useState} from "react";
import useSlideOverBaseline from "../../../useSlideOverBaseline";
import {toast} from "react-toastify";
import AddressGeoApi from "../../../../AddressGeoApi/AddressGeoApi";
import ApiDatabase from "server";
import { buildCompanySupplierFormOptions } from "../../../../../constants/missionSupplierFilters";
import {compareObjects} from "../../../../../helper/helper";
import {useNavigate} from "react-router-dom";
import useContext from "../../../../../hooks/useContext";
import TextSelectCollectiveAgreement from "../../../../textSelect/components/textSelectCollectiveAgreement";
import TextSelectSearchCompany from "../../../../textSelect/components/textSelectSearchCompany";
import StyledInput from "../../../../styledInput/StyledInput";
import {STATUS_LIST} from "components/companyForm/companyLegalForm";
import useModal from "../../../../modal/useModal";
import {Plus} from "../../../../../assets/icons";
import {useNotifyCompaniesChanged} from "hooks/useCompaniesChanged";
import {useNotifyRecordChanged} from "hooks/useRecordChanged";
import useCrmContext from "hooks/useCrmContext";
import crmApi from "server/crm/crmApi";
import {CLIENT_SIZES, clientSizeLabel} from "constants/clientSizes";

// The fields as the creation writes them: names in capitals, a first name with
// its capital, the numbers in digits only.
const SECTION_TITLE = 'text-sm font-medium text-gray-900'
const upper = (value) => value.toUpperCase()
const capitalized = (value) => value.charAt(0).toUpperCase() + value.slice(1)
const digits = (value) => value.replace(/[^0-9]/g, '')
const ape = (value) => value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

// What the api answers when a prospect cannot become a client (JBWEB-1422).
const COMPLETE_ERRORS = {
    SIRET_TAKEN: 'Une autre entreprise a déjà ce numéro de SIRET.',
    NOT_A_PROSPECT: 'Cette entreprise est déjà cliente.',
    PHONE_INVALID: 'Un des numéros de téléphone n’est pas valide.',
    ADMIN_ACCOUNT_REFUSED: 'Cet e-mail ne peut pas être celui de l’administrateur de l’entreprise.',
    COMPANY_NOT_FOUND: 'Cette entreprise n’existe plus.',
}

// The form's values from a company already in Jobbiz (admin/getCompanyInfo):
// a prospect keeps what it has, the rest stays to fill in.
const asText = (value) => (value === null || value === undefined || value === '' ? null : String(value))
const prefillOf = (info) => {
    const leader = info?.leader ?? {}
    return {
        reason_social: asText(info?.reason_social),
        name_commercial: asText(info?.name_commercial),
        status: asText(info?.status),
        code_ape: asText(info?.code_ape),
        siret: asText(info?.siret),
        staff: asText(info?.staff),
        capital: asText(info?.capital),
        pennylane_category_id: info?.pennylane_category_id ?? null,
        companySupplier: asText(info?.companySupplier),
        // The leader of a prospect is the person it was found through: the
        // admin account by default, the leader with it.
        email_admin: asText(leader.mail),
        lastname_admin: asText(leader.lastname),
        firstname_admin: asText(leader.firstname),
        phone_admin: asText(leader.phone),
    }
}
const addressOf = (info) => {
    const address = Array.isArray(info?.address) ? info.address[0] : info?.address
    if (!address) return {}
    const { street, complement, city, postcode, department, lat, lon } = address
    return { street, complement, city, postcode, department, lat, lon }
}

// `prepend`: what sits above the form (the « Type » of AddCompanyPanel).
// `completeCompanyId`: « Compléter la fiche client », the same form on a
// prospect that becomes a client (CompleteClientPanel): filled with what the
// prospect has, sent to admin/crm/company/client instead of company/add, so
// that no second company is created.
const SlideOverAddCompany = ({ prepend = null, completeCompanyId = null }) => {
    const completing = Boolean(completeCompanyId)
    const notifyRecordChanged = useNotifyRecordChanged()
    // Until the prospect's values are in, the form is not compared to them.
    const [prefilled, setPrefilled] = useState(!completing)
    const {removeAllParameters, modalDataReturn, setModalDataReturn, setSlideOverHasUnsavedChanges, language} = useContext();
    const {call} = useCrmContext();
    // A new company is a prospect: its size is chosen here (constants/clientSizes),
    // and kept by the CRM, not by the company itself.
    const [clientSize, setClientSize] = useState('');
    const {toggleSlideOver} = useSlideOver();
    const notifyCompaniesChanged = useNotifyCompaniesChanged();
    const {toggle} = useModal();
    const [searchCompany, setSearchCompany] = useState({})
    const [searchCollectiveAgreementDisplay, setSearchCollectiveAgreementDisplay] = useState('')
    const [addressLocation, setAddressLocation] = useState({})
    const [addressInvoice, setAddressInvoice] = useState('')
    const [isLeaderSameAsAdmin, setIsLeaderSameAsAdmin] = useState(true)
    const [isLocationSameAsInvoiceAddress, setIsLocationSameAsInvoiceAddress] = useState(true)
    const [isLoadingAddCompany, setIsLoadingAddCompany] = useState(false)
    const [pennylaneCategoryList, setPennylaneCategoryList] = useState([])
    const [companySupplierList, setCompanySupplierList] = useState([])
    const [addCompanyDatas, setAddCompanyDatas] = useState({
        reason_social: null,
        name_commercial: null,
        status: null,
        code_ape: null,
        conv_collective: null,
        siret: null,
        staff: null,
        capital: null,
        bank_transfer: true,
        cheque: false,
        location: {},
        invoice_address: '',
        email_admin: null,
        lastname_admin: null,
        firstname_admin: null,
        phone_admin:null,
        lastname_leader: null,
        firstname_leader: null,
        email_leader: null,
        phone_leader: null,
        coefficient_management: null,
        coefficient_delegation: null,
        pennylane_category_id: null,
        companySupplier: null,
    })
    const navigate = useNavigate()
    const token = localStorage.getItem('xsrfToken')

    useSlideOverBaseline({
        getSnapshot: () => ({
            addCompanyDatas,
            searchCompany,
            searchCollectiveAgreementDisplay,
            isLeaderSameAsAdmin,
            isLocationSameAsInvoiceAddress,
        }),
        deps: [
            addCompanyDatas,
            searchCompany,
            searchCollectiveAgreementDisplay,
            isLeaderSameAsAdmin,
            isLocationSameAsInvoiceAddress,
        ],
        setSlideOverHasUnsavedChanges,
        isReady: prefilled,
    })

    useEffect(() => {
        if (!completing) return
        ApiDatabase.getCompanyInfo({idCompany: completeCompanyId}, (data) => {
            const info = data?.company ?? null
            if (info) {
                setAddCompanyDatas(prevDatas => ({...prevDatas, ...prefillOf(info)}))
                const address = addressOf(info)
                if (Object.keys(address).length) setAddressLocation(address)
                if (info.conv_collective) setSearchCollectiveAgreementDisplay(String(info.conv_collective))
            }
            setPrefilled(true)
        }, (err) => {
            if (err.name !== 'CanceledError') setPrefilled(true)
        })
    }, [completing, completeCompanyId])

    const setField = (field, clean = (value) => value) => (event) =>
        setAddCompanyDatas(prevDatas => ({...prevDatas, [field]: clean(event.target.value)}))

    const submitCompany = () => {
        if (!clientSize) {
            toast.error(language.getValue('clientSizes.required', ''))
            return
        }
        if(
            addCompanyDatas.reason_social &&
            addCompanyDatas.name_commercial &&
            addCompanyDatas.siret &&
            addCompanyDatas.status &&
            addCompanyDatas.bank_transfer !== null &&
            addCompanyDatas.cheque !== null &&
            addCompanyDatas.location &&
            addCompanyDatas.invoice_address &&
            addCompanyDatas.email_admin &&
            addCompanyDatas.lastname_admin &&
            addCompanyDatas.firstname_admin &&
            addCompanyDatas.phone_admin &&
            addCompanyDatas.email_leader &&
            addCompanyDatas.lastname_leader &&
            addCompanyDatas.firstname_leader &&
            addCompanyDatas.phone_leader
        ) {
            setIsLoadingAddCompany(true)
            if (completing) {
                call(crmApi.completeClient, {companyId: completeCompanyId, company: addCompanyDatas}).then(() => {
                    call(crmApi.setCompanySize, {companyId: completeCompanyId, size: clientSize}).catch(() => {})
                    toast.success('L’entreprise est passée en client')
                    closeSlideOver()
                    notifyCompaniesChanged()
                    notifyRecordChanged()
                }, (err) => {
                    setIsLoadingAddCompany(false)
                    if (err?.name === 'CanceledError') return
                    toast.error(COMPLETE_ERRORS[err?.response?.data?.errorCode] ?? 'Le passage en client a échoué.')
                })
                return
            }
            ApiDatabase.postAddCompany({token: token, company: addCompanyDatas}, (data) => {
                // Its page reads the size it was given.
                call(crmApi.setCompanySize, {companyId: String(data.company), size: clientSize}).catch(() => {})
                toast.success('Entreprise ajoutée')
                closeSlideOver()
                notifyCompaniesChanged()
                navigate('/company/' + data.company)
                setIsLoadingAddCompany(false)
            }, (err) => {
                if (err.name !== "CanceledError") {
                    if (err?.response?.data?.message) toast.error(err?.response?.data?.message)
                    setIsLoadingAddCompany(false)
                }
            })
        } else {
            toast.error('Veuillez remplir tous les champs')
        }
    }

    useEffect(() => {
        if (!compareObjects(addCompanyDatas?.location, addressLocation) && Object.keys(addressLocation).length > 0) {
            setAddCompanyDatas(prevDatas => ({...prevDatas, location: addressLocation}))
        }
    }, [addressLocation]);

    useEffect(() => {
        if (!compareObjects(addCompanyDatas?.invoice_address, addressInvoice) && Object.keys(addressInvoice).length > 0) {
            setAddCompanyDatas(prevDatas => ({...prevDatas, invoice_address: addressInvoice}))
        }
    }, [addressInvoice]);

    useEffect(() => {
        if(isLeaderSameAsAdmin) {
            setAddCompanyDatas(prevDatas => ({
                ...prevDatas,
                lastname_leader: addCompanyDatas.lastname_admin,
                firstname_leader: addCompanyDatas.firstname_admin,
                email_leader: addCompanyDatas.email_admin,
                phone_leader: addCompanyDatas.phone_admin
            }))
        } else {
            setAddCompanyDatas(prevDatas => ({
                ...prevDatas,
                lastname_leader: '',
                firstname_leader: '',
                email_leader: '',
                phone_leader: ''
            }))
        }
    }, [isLeaderSameAsAdmin, addCompanyDatas.lastname_admin, addCompanyDatas.firstname_admin, addCompanyDatas.email_admin, addCompanyDatas.phone_admin]);

    useEffect(() => {
        if(isLocationSameAsInvoiceAddress) {
            setAddCompanyDatas(prevDatas => ({
                ...prevDatas,
                invoice_address: addCompanyDatas.location
            }))
            setAddressInvoice(addCompanyDatas.location)
        } else {
            setAddCompanyDatas(prevDatas => ({...prevDatas, invoice_address: ''}))
            setAddressInvoice('')
        }
    }, [isLocationSameAsInvoiceAddress, addCompanyDatas.location]);

    useEffect(() => {
        //remove , and . from siret
        if(addCompanyDatas.siret) {
            setAddCompanyDatas(prevDatas => ({...prevDatas, siret: addCompanyDatas.siret.replace(/,/g, '').replace(/\./g, '').slice(0, 14)}))
        }
        if(addCompanyDatas.staff) {
            setAddCompanyDatas(prevDatas => ({...prevDatas, staff: addCompanyDatas.staff.replace(/,/g, '').replace(/\./g, '').slice(0, 8)}))
        }
        if(addCompanyDatas.capital) {
            setAddCompanyDatas(prevDatas => ({...prevDatas, capital: addCompanyDatas.capital.replace(/,/g, '').replace(/\./g, '').slice(0, 8)}))
        }
        //change , by .
        if(addCompanyDatas.coefficient_management) {
            setAddCompanyDatas(prevDatas => ({...prevDatas, coefficient_management: addCompanyDatas.coefficient_management.replace(/,/g, '.').slice(0, 4)}))
        }
        if(addCompanyDatas.coefficient_delegation) {
            setAddCompanyDatas(prevDatas => ({...prevDatas, coefficient_delegation: addCompanyDatas.coefficient_delegation.replace(/,/g, '.').slice(0, 4)}))
        }
        if(addCompanyDatas.email_admin) {
            setAddCompanyDatas(prevDatas => ({...prevDatas, email_admin: addCompanyDatas.email_admin.toLowerCase().replace(/\s/g, '')}))
        }
        if(addCompanyDatas.email_leader) {
            setAddCompanyDatas(prevDatas => ({...prevDatas, email_leader: addCompanyDatas.email_leader.toLowerCase().replace(/\s/g, '')}))
        }
    }, [addCompanyDatas.siret, addCompanyDatas.staff, addCompanyDatas.capital, addCompanyDatas.email_admin, addCompanyDatas.email_leader, addCompanyDatas.coefficient_management, addCompanyDatas.coefficient_delegation])

    const loadPennyLaneCategories = () => {
        ApiDatabase.getPennyLaneCategories({token}, (data) => {
            setPennylaneCategoryList(data?.items || [])
        }, (err) => {
            if (err.name !== 'CanceledError') console.error(err)
        })
    }

    useEffect(() => {
        loadPennyLaneCategories()
        ApiDatabase.getCompanySuppliers({}, (data) => {
            setCompanySupplierList(Array.isArray(data) ? data : [])
        }, (err) => {
            if (err.name !== 'CanceledError') console.error(err)
        })
    }, [])

    useEffect(() => {
        if (modalDataReturn?.createdCategory) {
            loadPennyLaneCategories()
            setModalDataReturn({})
        }
    }, [modalDataReturn])

    const closeSlideOver = () => {
        toggleSlideOver()
        removeAllParameters()
    }

    useEffect(() => {
        if (!Object.keys(searchCompany || {}).length) return;

        const reasonSocial = searchCompany.nom_entreprise || null;
        const nameCommercial = searchCompany.siege?.nom_commercial ?? reasonSocial ?? null;
        const siretNumber = searchCompany.siege?.siret || null;
        const workforce = searchCompany.siege?.effectif ? searchCompany.siege.effectif.replace(/[^0-9]/g, '') : null;
        const apeCode = searchCompany.siege?.code_naf ? searchCompany.siege.code_naf.replace(/\./g, '') : null;
        const socialCapital = searchCompany.capital_formate ? Math.round(parseFloat(searchCompany.capital_formate.replace(/\s/g, '').replace(',', '.').replace(/[^0-9.]/g, ''))).toString() : null;
        const legalForm = searchCompany.forme_juridique ? searchCompany.forme_juridique.split(',')[0] : null;
        const collectiveAgreement = (searchCompany.conventions_collectives && searchCompany.conventions_collectives.length > 0) ? searchCompany.conventions_collectives[0].idcc : null;

        const street = searchCompany.siege?.libelle_voie || null;
        const addressComplement = searchCompany.siege?.complement_adresse || null;
        const city = searchCompany.siege?.ville || null;
        const postalCode = searchCompany.siege?.code_postal || null;
        const department = searchCompany.siege?.departement || null;

        const address = {
            street: street,
            complement: addressComplement,
            city: city,
            postcode: postalCode,
            department: department,
        };

        setAddCompanyDatas(prevDatas => ({
            ...prevDatas,
            reason_social: reasonSocial,
            name_commercial: nameCommercial,
            siret: siretNumber,
            staff: workforce,
            code_ape: apeCode,
            capital: socialCapital,
            status: legalForm
        }))

        setAddressLocation(address)
        if (collectiveAgreement) setSearchCollectiveAgreementDisplay(collectiveAgreement)
    }, [searchCompany])

    return (
        <>
            <SlideOverHeader hide={closeSlideOver} hideShow={true}>
                {completing ? 'Compléter la fiche client' : 'Ajouter une entreprise'}
            </SlideOverHeader>
            <SlideOverBody>
                <div className={'flex flex-col gap-6'}>
                    {prepend}
                    <TextSelectSearchCompany searchCompany={searchCompany} setSearchCompany={setSearchCompany}/>
                    <StyledInput
                        type="select"
                        label={language.getValue('clientSizes.label', '')}
                        placeholder={language.getValue('clientSizes.none', '')}
                        list={CLIENT_SIZES.map((size) => ({value: size, label: clientSizeLabel(language, size)}))}
                        value={clientSize}
                        onChange={(event) => setClientSize(event.target.value)}
                    />
                    <h4 className={SECTION_TITLE}>Informations légales</h4>
                    <StyledInput type="text" label="Raison sociale" value={addCompanyDatas.reason_social ?? ''} maxLength={50} onChange={setField('reason_social', upper)}/>
                    <StyledInput type="text" label="Nom commercial" value={addCompanyDatas.name_commercial ?? ''} maxLength={50} onChange={setField('name_commercial', upper)}/>
                    <div className={'grid grid-cols-2 gap-4'}>
                        <StyledInput type="text" inputMode="numeric" label="SIRET" value={addCompanyDatas.siret ?? ''} maxLength={14} onChange={setField('siret', digits)}/>
                        <StyledInput type="text" inputMode="numeric" label="Effectif" isOptional value={addCompanyDatas.staff ?? ''} maxLength={8} onChange={setField('staff', digits)}/>
                        <StyledInput type="text" label="Code APE" isOptional value={addCompanyDatas.code_ape ?? ''} maxLength={5} onChange={setField('code_ape', ape)}/>
                        <StyledInput type="number" step="0.01" label="Capital social" isOptional value={addCompanyDatas.capital ?? ''} onChange={setField('capital')}/>
                        <StyledInput type="select" label="Forme juridique" value={addCompanyDatas.status ?? ''} list={STATUS_LIST.map((option) => ({...option, value: option.value ?? ''}))} onChange={setField('status', (value) => value || null)}/>
                        <StyledInput type="select" label="Fournisseur" isOptional value={addCompanyDatas.companySupplier || ''} list={buildCompanySupplierFormOptions(companySupplierList)} onChange={setField('companySupplier', (value) => value || null)}/>
                    </div>
                    <TextSelectCollectiveAgreement
                        collectiveAgreement={addCompanyDatas.conv_collective}
                        setCollectiveAgreement={(data) => setAddCompanyDatas(prevDatas => ({...prevDatas, conv_collective: data}))}
                        searchCollectiveAgreementDisplay={searchCollectiveAgreementDisplay}
                    />
                    <Divider/>
                    <h4 className={SECTION_TITLE}>Compte administrateur</h4>
                    <div className={'grid grid-cols-2 gap-4'}>
                        <StyledInput type="text" label="Nom" value={addCompanyDatas.lastname_admin ?? ''} onChange={setField('lastname_admin', upper)}/>
                        <StyledInput type="text" label="Prénom" value={addCompanyDatas.firstname_admin ?? ''} onChange={setField('firstname_admin', capitalized)}/>
                        <StyledInput type="email" label="E-mail" value={addCompanyDatas.email_admin ?? ''} onChange={setField('email_admin')}/>
                        <StyledInput type="text" label="Téléphone" value={addCompanyDatas.phone_admin ?? ''} onChange={setField('phone_admin')}/>
                    </div>
                    <Divider/>
                    <h4 className={SECTION_TITLE}>Contact dirigeant</h4>
                    <StyledInput
                        type="checkbox"
                        label="Le contact est le même que l'administrateur"
                        checked={isLeaderSameAsAdmin}
                        onChange={() => setIsLeaderSameAsAdmin(!isLeaderSameAsAdmin)}
                    />
                    <div className={'grid grid-cols-2 gap-4'}>
                        <StyledInput type="text" label="Nom" value={addCompanyDatas.lastname_leader ?? ''} isDisabled={isLeaderSameAsAdmin} onChange={setField('lastname_leader', upper)}/>
                        <StyledInput type="text" label="Prénom" value={addCompanyDatas.firstname_leader ?? ''} isDisabled={isLeaderSameAsAdmin} onChange={setField('firstname_leader', capitalized)}/>
                        <StyledInput type="email" label="E-mail" value={addCompanyDatas.email_leader ?? ''} isDisabled={isLeaderSameAsAdmin} onChange={setField('email_leader')}/>
                        <StyledInput type="text" label="Téléphone" value={addCompanyDatas.phone_leader ?? ''} isDisabled={isLeaderSameAsAdmin} onChange={setField('phone_leader')}/>
                    </div>
                    <Divider/>
                    <h4 className={SECTION_TITLE}>Méthode de facturation</h4>
                    <div className={'w-full flex gap-4'}>
                        <div className={`my-auto p-3 text-center w-full border rounded cursor-pointer ${addCompanyDatas.bank_transfer ? 'bg-yellow-500 text-white' : 'bg-gray-50'}`} onClick={() => {
                            setAddCompanyDatas(prevDatas => ({...prevDatas, bank_transfer: true, cheque: false}))
                        }}>
                            Transfert bancaire
                        </div>
                        <div className={`my-auto p-3 text-center w-full border rounded cursor-pointer ${addCompanyDatas.cheque ? 'bg-yellow-500 text-white' : 'bg-gray-50'}`} onClick={() => {
                            setAddCompanyDatas(prevDatas => ({...prevDatas, bank_transfer: false, cheque: true}))
                        }}>
                            Chèque
                        </div>
                    </div>
                    <Divider/>
                    <h4 className={SECTION_TITLE}>Adresse de l'entreprise</h4>
                    <div className={'w-full'}>
                        <AddressGeoApi
                          label={'Adresse'}
                          addressGeoValue={setAddressLocation}
                          addressValue={addressLocation}
                          page={'createCompany'}
                        />
                    </div>
                    <Divider/>
                    <h4 className={SECTION_TITLE}>Adresse de facturation</h4>
                    <StyledInput
                        type="checkbox"
                        label="L'adresse de facturation est la même que l'adresse de l'entreprise"
                        checked={isLocationSameAsInvoiceAddress}
                        onChange={() => setIsLocationSameAsInvoiceAddress(!isLocationSameAsInvoiceAddress)}
                    />
                    {!isLocationSameAsInvoiceAddress && (
                        <div className={'w-full'}>
                            <AddressGeoApi
                              label={'Adresse'}
                              addressGeoValue={setAddressInvoice}
                              addressValue={addressInvoice}
                              page={'createCompany'}
                            />
                        </div>
                    )}
                    <Divider/>
                    <h4 className={SECTION_TITLE}>Activité</h4>
                    <div className={'w-full'}>
                        {(() => {
                            const selectedCat = pennylaneCategoryList.find(c => c.id === addCompanyDatas.pennylane_category_id)
                            const createCategoryFooter = (
                                <div
                                    className="flex items-center gap-1 p-1 cursor-pointer"
                                    onClick={() => toggle('company_pennylane_create_category')}
                                >
                                    <Plus wh={20} color="#374151" />
                                    Créer une catégorie
                                </div>
                            )
                            return (
                                <StyledInput
                                    label="Catégorie"
                                    isOptional
                                    type="selectMultipleRadio"
                                    isSearchable
                                    value={selectedCat?.label || ''}
                                    list={pennylaneCategoryList.map(cat => ({
                                        value: cat.id,
                                        label: cat.label,
                                        checked: cat.id === addCompanyDatas.pennylane_category_id,
                                    }))}
                                    onChange={(updated) => {
                                        const selected = updated.find(opt => opt.checked)
                                        setAddCompanyDatas(prev => ({ ...prev, pennylane_category_id: selected?.value ?? null }))
                                    }}
                                    footer={createCategoryFooter}
                                />
                            )
                        })()}
                    </div>
                    <Divider/>
                    <h4 className={SECTION_TITLE}>Coefficients de facturation</h4>
                    <div className={'grid grid-cols-2 gap-4'}>
                        <StyledInput type="number" step="0.01" label="Gestion" isOptional value={addCompanyDatas.coefficient_management ?? ''} maxLength={4} onChange={setField('coefficient_management')}/>
                        <StyledInput type="number" step="0.01" label="Délégation" isOptional value={addCompanyDatas.coefficient_delegation ?? ''} maxLength={4} onChange={setField('coefficient_delegation')}/>
                    </div>
                </div>
            </SlideOverBody>
            <SlideOverFooter>
                <Button size={'SM'} color={'SECONDARY'} onClick={closeSlideOver}>Annuler</Button>
                {isLoadingAddCompany ? (
                    <Button size={'SM'} color={'DISABLED'}>
                        {completing ? 'Passage en client ...' : "Création de l'entreprise ..."}
                    </Button>
                ) : (
                    <Button size={'SM'} color={'PRIMARY'} onClick={submitCompany}>
                        {completing ? 'Passer en client' : 'Confirmer'}
                    </Button>
                )}
            </SlideOverFooter>
        </>
    )
}

export default SlideOverAddCompany